var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2701_9893"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2701_9893)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.889,15.99996103553772L2,15.99996103553772C1.447715,15.99996103553772,1,15.55226103553772,1,14.99996103553772L1,9.00000103553772C1,8.447711035537719,1.447715,8.00000103553772,2,8.00000103553772L5.889,8.00000103553772L11.183,3.6680000355377196C11.3325,3.5454199355377196,11.5393,3.5200295355377196,11.714,3.6027975355377198C11.8888,3.68556503553772,12.0001,3.86165603553772,12,4.05500003553772L12,19.94496103553772C12.0001,20.13836103553772,11.8888,20.314461035537718,11.714,20.39716103553772C11.5393,20.47996103553772,11.3325,20.45456103553772,11.183,20.33196103553772L5.889,15.99996103553772L5.889,15.99996103553772ZM20.414,12.00000103553772L23.95,15.535961035537719L22.536,16.94996103553772L19,13.41400103553772L15.464,16.94996103553772L14.05,15.535961035537719L17.586,12.00000103553772L14.05,8.46400103553772L15.464,7.05000103553772L19,10.58600103553772L22.536,7.05000103553772L23.95,8.46400103553772L20.414,12.00000103553772Z",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.afa0fccd68cb6875f566e3ae7f94868e.svg";
export { ForwardRef as ReactComponent };